<div style="width: 600px; height: 200px;" data-cy="upload-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="upload-dialog-header-section">
      <div class="section-header-title" data-cy="upload-dialog-title-text">
        Upload progress ...
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: center; font-size: 48px; font-weight: 500; color: var(--tdo-primary-accent);" data-cy="upload-dialog-content-section">
      <div data-cy="upload-dialog-progress-text">{{uploadProgress}}%</div>
      <mat-progress-bar style="width: 100%;" [value]="uploadProgress" data-cy="upload-dialog-progress-bar"></mat-progress-bar>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="upload-dialog-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="upload-dialog-cancel-button">Cancel</button>
    </div>
  </div>
</div>
